export const EvaluationPerformanceGravity = {
    path: '/evaluation_performance_gravities',
    name: 'evaluation_performance_gravities',
    component: () => import('@/views/Evaluation/Gravity/EvaluationPerformanceGravityPage.vue'),
    props: {
        tyep: 'EVALUATION_PERFORMANCE',  
    },
    children: [
        {
            path: '/evaluation_performance_gravities/add',
            name: 'evaluation_performance_gravities.add',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                addAction: true,
                tyep: 'EVALUATION_PERFORMANCE',
            }
        },
        {
            path: '/evaluation_performance_gravities/edit/:id',
            name: 'evaluation_performance_gravities.edit',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                updateAction: true,
                tyep: 'EVALUATION_PERFORMANCE',
            }
        },
        {
            path: '/evaluation_performance_gravities/delete/:id',
            name: 'evaluation_performance_gravities.delete',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                deleteAction: true,
                tyep: 'EVALUATION_PERFORMANCE',
            }
        },
        {
            path: '/evaluation_performance_gravities/view/:id',
            name: 'evaluation_performance_gravities.view',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                viewAction: true,
                tyep: 'EVALUATION_PERFORMANCE',
            }
        },
    ]
}